import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Moment from 'moment';
import { getAttendanceColor } from 'helpers/attendance';
import { setPageTitle } from 'actions/header';
import { getUserAbsence, submitAbsence, updateAbsence } from 'actions/absence';
import Modal from '@mui/material/Modal';
import AppModal from 'containers/Modals/Modal';
import ReportAbsenceForm from 'containers/Forms/ReportAbsence';
import { Flex, translate, getActiveLanguage, Button, Icon } from '@haldor/ui';
/* leave application UI removed from this page; use /leaves route */
import { Tabs, Tab, Box, Typography } from '@mui/material';
import { Expandable, Spinner } from 'UI';
import MuiAlert from '@mui/material/Alert';
import Snackbar from '@mui/material/Snackbar';
import './_Absence.scss';
var Alert = /*#__PURE__*/React.forwardRef(function Alert(props, ref) {
  return /*#__PURE__*/React.createElement(MuiAlert, _extends({
    elevation: 6,
    ref: ref,
    variant: "filled"
  }, props));
});
var Absence = /*#__PURE__*/function (_Component) {
  function Absence(props) {
    var _this;
    _classCallCheck(this, Absence);
    _this = _callSuper(this, Absence, [props]);
    _defineProperty(_this, "componentDidMount", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var translate, hash, validTabs, initialValue;
      return _regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            translate = _this.props.translate;
            _this.props.setPageTitle(translate('Absence'));
            // Listen to hash changes (back/forward navigation)
            window.addEventListener('hashchange', _this.onHashChange);
            window.addEventListener('resize', _this.onResize);

            // Initialize tab from hash if present and load data
            hash = (window.location.hash || '').replace('#', '');
            validTabs = ['report-absence', 'reported-absences'];
            initialValue = validTabs.includes(hash) ? hash : 'report-absence';
            _this.setState({
              tabValue: initialValue
            });
            if (!(initialValue === 'reported-absences' && _this.props.student && _this.props.absences == null)) {
              _context.next = 2;
              break;
            }
            _this.setState({
              loading: true
            });
            _context.next = 1;
            return _this.props.getUserAbsence(_this.props.student.id, _this.state.start, _this.state.end);
          case 1:
            _this.setState({
              loading: false
            });
          case 2:
            _this.setState({
              loading: false
            });
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_this, "onHashChange", /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var hash;
      return _regeneratorRuntime.wrap(function (_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            hash = (window.location.hash || '').replace('#', '');
            if (!['report-absence', 'reported-absences'].includes(hash)) {
              _context2.next = 3;
              break;
            }
            if (!(_this.state.tabValue === hash)) {
              _context2.next = 1;
              break;
            }
            return _context2.abrupt("return");
          case 1:
            _this.setState({
              tabValue: hash
            });
            if (!(hash === 'reported-absences' && _this.props.absences == null && _this.props.student)) {
              _context2.next = 3;
              break;
            }
            _this.setState({
              loading: true
            });
            _context2.next = 2;
            return _this.props.getUserAbsence(_this.props.student.id, _this.state.start, _this.state.end);
          case 2:
            _this.setState({
              loading: false
            });
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })));
    _defineProperty(_this, "onResize", function () {
      var isMobile = window.innerWidth < 600;
      if (isMobile !== _this.state.isMobile) {
        _this.setState({
          isMobile: isMobile
        });
      }
    });
    _defineProperty(_this, "UNSAFE_componentWillReceiveProps", /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(nextProps) {
        return _regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(nextProps.student != null && _this.props.student.id != nextProps.student.id)) {
                _context3.next = 2;
                break;
              }
              _context3.next = 1;
              return _this.props.getUserAbsence(nextProps.student.id, _this.state.start, _this.state.end);
            case 1:
              _this.setState({
                loading: false
              });
            case 2:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }));
      return function (_x) {
        return _ref3.apply(this, arguments);
      };
    }());
    _defineProperty(_this, "onAbsenceClick", function (absence) {
      if (absence == null) {
        return false;
      }
      if (!absence.ownReporting) {
        return false;
      }
      _this.setState({
        modalOpen: true,
        selectedAbsence: absence
      });
    });
    _defineProperty(_this, "getAttendanceProps", function (attendance) {
      var translate = _this.props.translate;
      var indicatorColor = '#DBDBDB';
      var content = translate('Not reported');
      if (attendance == null) {
        return {
          color: indicatorColor,
          text: content
        };
      }
      if (attendance.attendanceType == 'PRESENT') {
        content = translate('Present');
      }
      if (attendance.attendanceType == 'INVALID_ABSENCE') {
        content = translate('Invalid absent');
      }
      if (attendance.attendanceType == 'VALID_ABSENCE') {
        content = translate('Valid absent');
      }
      if (attendance.attendanceType == 'INVALID_LATE') {
        content = translate('Partly invalid absent');
        if (attendance.lateDuration != null) {
          content += ' - ' + attendance.lateDuration + ' ' + translate('minutes');
        }
      }
      if (attendance.attendanceType == 'VALID_LATE') {
        content = translate('Partly absent');
        if (attendance.lateDuration != null) {
          content += ' - ' + attendance.lateDuration + ' ' + translate('minutes');
        }
      }
      indicatorColor = getAttendanceColor(attendance);
      return {
        color: indicatorColor,
        text: content
      };
    });
    _defineProperty(_this, "renderItem", function (absence) {
      var _absence$reportedBy, _absence$reportedBy2, _absence$editor, _absence$editor2;
      var formatting = 'D MMMM YYYY';
      var start = Moment.utc(absence.startTime).local();
      var end = Moment.utc(absence.endTime).local();
      var translate = _this.props.translate;
      var absenceAttendance = {
        attendanceType: absence.type
      };
      if (absence.origin == 'ATTENDANCE') {
        var _absence$calendarEven;
        absenceAttendance.lateDuration = (_absence$calendarEven = absence.calendarEvents[0]) === null || _absence$calendarEven === void 0 || (_absence$calendarEven = _absence$calendarEven.attendance) === null || _absence$calendarEven === void 0 ? void 0 : _absence$calendarEven.lateDuration;
      }
      var attendance = _this.getAttendanceProps(absenceAttendance);
      var showAlert = false;
      if (absence.calendarEvents != null) {
        showAlert = absence.calendarEvents.find(function (lesson) {
          if (lesson.attendance.attendanceType != null) {
            return lesson.attendance.attendanceType.indexOf('INVALID') > -1;
          }
          return false;
        }) != null;
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "new-card",
        key: "ab-".concat(absence.id)
      }, /*#__PURE__*/React.createElement("div", {
        className: "absence-item-content"
      }, /*#__PURE__*/React.createElement(Flex, {
        space: true
      }, !absence.ownReporting ? /*#__PURE__*/React.createElement("div", {
        className: "column",
        style: {
          flex: 1,
          whiteSpace: 'nowrap'
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('Status')), /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          alignItems: 'center'
        }
      }, attendance.color != '#fff' ? /*#__PURE__*/React.createElement("span", {
        className: "indicator",
        style: {
          backgroundColor: attendance.color
        }
      }) : null, attendance.text)) : absence.calendarEvents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        className: "column space-placeholder"
      }, showAlert ? /*#__PURE__*/React.createElement("div", {
        className: "invalid-absent-badge"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Alert_Red"
      })) : null) : null, absence.origin == 'ATTENDANCE' ? /*#__PURE__*/React.createElement("div", {
        className: "colum",
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('From')), absence.calendarEvents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: 'nowrap'
        }
      }, Moment.utc(absence.calendarEvents[0].startTime).local().format(formatting), /*#__PURE__*/React.createElement("div", null, Moment.utc(absence.calendarEvents[0].startTime).local().format('HH:mm'))) : null) : /*#__PURE__*/React.createElement("div", {
        className: "column",
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('From')), /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: 'nowrap'
        }
      }, start.format(formatting), !absence.period ? /*#__PURE__*/React.createElement("div", null, start.format('HH:mm')) : null)), absence.origin == 'ATTENDANCE' ? /*#__PURE__*/React.createElement("div", {
        className: "colum",
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('To')), absence.calendarEvents.length > 0 ? /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: 'nowrap'
        }
      }, Moment.utc(absence.calendarEvents[0].startTime).local().add(absence.calendarEvents[0].length, 'minutes').format(formatting), /*#__PURE__*/React.createElement("div", null, Moment.utc(absence.calendarEvents[0].startTime).local().add(absence.calendarEvents[0].length, 'minutes').format('HH:mm'))) : null) : /*#__PURE__*/React.createElement("div", {
        className: "column",
        style: {
          flex: 1
        }
      }, /*#__PURE__*/React.createElement("strong", null, translate('To')), /*#__PURE__*/React.createElement("div", {
        style: {
          whiteSpace: 'nowrap'
        }
      }, end.format(formatting), !absence.period ? /*#__PURE__*/React.createElement("div", null, end.format('HH:mm')) : null)), /*#__PURE__*/React.createElement("div", {
        className: "column",
        style: {
          whiteSpace: 'nowrap'
        }
      }, absence.origin == 'ATTENDANCE' ? /*#__PURE__*/React.createElement("strong", null, translate('Reported by')) : /*#__PURE__*/React.createElement("strong", null, translate('Registered by')), /*#__PURE__*/React.createElement("div", null, absence.reportedBy != null ? "".concat(((_absence$reportedBy = absence.reportedBy) === null || _absence$reportedBy === void 0 ? void 0 : _absence$reportedBy.firstName) || '', " ").concat(((_absence$reportedBy2 = absence.reportedBy) === null || _absence$reportedBy2 === void 0 ? void 0 : _absence$reportedBy2.lastName) || '') : null, absence.editor != null && absence.editor.userId != null && (absence.editor.firstName || absence.editor.lastName) ? /*#__PURE__*/React.createElement("div", null, translate('Edited by') + ' ' + "".concat(((_absence$editor = absence.editor) === null || _absence$editor === void 0 ? void 0 : _absence$editor.firstName) || '', " ").concat(((_absence$editor2 = absence.editor) === null || _absence$editor2 === void 0 ? void 0 : _absence$editor2.lastName) || '')) : null)), absence.ownReporting == true ? /*#__PURE__*/React.createElement("div", {
        className: "column",
        style: {
          display: 'flex'
        }
      }, /*#__PURE__*/React.createElement("div", {
        onClick: function onClick(e) {
          return _this.onAbsenceClick(absence);
        },
        className: "edit-trigger"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Pen_Small"
      }))) : null)), absence.calendarEvents != null && absence.calendarEvents.length > 0 && absence.ownReporting == true ? /*#__PURE__*/React.createElement(Expandable, {
        title: "1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "lessons"
      }, /*#__PURE__*/React.createElement("strong", null, _this.props.translate('Lessons')), absence.calendarEvents.map(function (lesson) {
        var _lesson$section, _lesson$attendance$re, _lesson$attendance$re2;
        var attendance = _this.getAttendanceProps(lesson.attendance);
        var start = Moment.utc(lesson.startTime).local();
        var end = Moment.utc(lesson.startTime).add(lesson.length, 'minutes').local();
        return /*#__PURE__*/React.createElement("div", {
          className: "lesson-item",
          key: lesson.id
        }, /*#__PURE__*/React.createElement(Flex, null, /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, /*#__PURE__*/React.createElement("span", {
          className: "indicator",
          style: {
            backgroundColor: attendance.color != '#fff' ? attendance.color : '#ccc'
          }
        }), attendance.text), /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, start.format('D MMMM YYYY, H:mm'), "-", end.format('H:mm')), /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, (_lesson$section = lesson.section) === null || _lesson$section === void 0 ? void 0 : _lesson$section.title), lesson.attendance != null && lesson.attendance.reportedByUser != null ? /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, translate('Reported by') + ': ', "".concat(((_lesson$attendance$re = lesson.attendance.reportedByUser) === null || _lesson$attendance$re === void 0 ? void 0 : _lesson$attendance$re.firstName) || '', " ").concat(((_lesson$attendance$re2 = lesson.attendance.reportedByUser) === null || _lesson$attendance$re2 === void 0 ? void 0 : _lesson$attendance$re2.lastName) || '')) : /*#__PURE__*/React.createElement("div", {
          className: "column"
        }, "-")));
      }))) : null);
    });
    _defineProperty(_this, "toggleModal", function () {
      _this.setState({
        modalOpen: !_this.state.modalOpen,
        selectedAbsence: null
      });
    });
    _defineProperty(_this, "onModalAbort", function () {
      _this.props.getUserAbsence(_this.props.student.id, _this.state.start, _this.state.end);
      _this.toggleModal();
    });
    _defineProperty(_this, "onAbsenceSubmit", function (values) {
      return new Promise(function (resolve, reject) {
        if (values.id != null) {
          _this.props.updateAbsence(values).then(function () {
            resolve(1);
            if (_this.props.submitResult != null && _this.props.submitResult.success == true) {
              _this.props.getUserAbsence(_this.props.student.id, _this.state.start, _this.state.end);
              _this.toggleModal();
            }
          })["catch"](function (error) {
            reject(error);
          });
        } else {
          _this.props.submitAbsence(values).then(function () {
            resolve(1);
            if (_this.props.submitResult != null && _this.props.submitResult.success == true) {
              _this.props.getUserAbsence(_this.props.student.id, _this.state.start, _this.state.end);
              _this.toggleModal();
              var student = _this.props.student;
              var studentName = "".concat((student === null || student === void 0 ? void 0 : student.firstName) || '', " ").concat((student === null || student === void 0 ? void 0 : student.lastName) || '');
              var fromToText = Moment.utc(values.startTime).local().format('YYYY-MM-DD HH:mm') + " " + _this.props.translate('to') + " " + Moment.utc(values.endTime).local().format('YYYY-MM-DD HH:mm');
              _this.setState({
                recentAddedText: studentName + " " + _this.props.translate('has been reported as absent') + " " + fromToText
              });
            }
          })["catch"](function (error) {
            reject(error);
          });
        }
      });
    });
    _defineProperty(_this, "handleTabChange", /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(event, newValue) {
        return _regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this.setState({
                tabValue: newValue,
                recentAddedText: null
              });
              if (!(newValue === 'reported-absences')) {
                _context4.next = 2;
                break;
              }
              _this.setState({
                loading: true
              });
              if (!(_this.props.absences == null && _this.props.student)) {
                _context4.next = 1;
                break;
              }
              _context4.next = 1;
              return _this.props.getUserAbsence(_this.props.student.id, _this.state.start, _this.state.end);
            case 1:
              _this.setState({
                loading: false
              });
            case 2:
              if (window.location.hash !== '#' + newValue) {
                window.history.replaceState(null, '', '#' + newValue);
              }
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x2, _x3) {
        return _ref4.apply(this, arguments);
      };
    }());
    Moment.locale(getActiveLanguage());
    _this.state = {
      start: Moment().subtract(1, 'months').set({
        'minutes': 0,
        'hours': 0
      }).format('YYYY-MM-DD'),
      end: Moment().add(3, 'months').set({
        'minutes': 59,
        'hours': 23
      }).format('YYYY-MM-DD'),
      modalOpen: false,
      leaveModalOpen: false,
      leaveViewOpen: false,
      loading: true,
      recentAddedText: null,
      tabValue: 'report-absence',
      isMobile: typeof window !== 'undefined' ? window.innerWidth < 600 : false,
      selectedLeaveApplication: null,
      alertOpen: false,
      alertMessage: '',
      alertSeverity: 'success'
    };
    return _this;
  }
  _inherits(Absence, _Component);
  return _createClass(Absence, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('hashchange', this.onHashChange);
      window.removeEventListener('resize', this.onResize);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        modalOpen = _this$state.modalOpen,
        leaveModalOpen = _this$state.leaveModalOpen,
        leaveViewOpen = _this$state.leaveViewOpen,
        tabValue = _this$state.tabValue,
        selectedLeaveApplication = _this$state.selectedLeaveApplication,
        alertOpen = _this$state.alertOpen,
        alertMessage = _this$state.alertMessage,
        alertSeverity = _this$state.alertSeverity;
      var absences = null;
      if (this.props.absences != null) {
        absences = this.props.absences.sort(function (a, b) {
          return a.startTime < b.startTime ? 1 : b.startTime < a.startTime ? -1 : 0;
        });
      }
      var translate = this.props.translate;
      return /*#__PURE__*/React.createElement("div", {
        className: "page absence"
      }, /*#__PURE__*/React.createElement(AppModal, {
        title: translate('Manage absence'),
        isOpen: modalOpen,
        onClose: this.toggleModal
      }, /*#__PURE__*/React.createElement(ReportAbsenceForm, {
        onSubmit: this.onAbsenceSubmit,
        user: this.props.student.id,
        absence: this.state.selectedAbsence,
        onAbort: this.onModalAbort
      })), /*#__PURE__*/React.createElement(Tabs, {
        value: tabValue,
        onChange: this.handleTabChange,
        variant: "scrollable",
        scrollButtons: "auto",
        "aria-label": "absence tabs",
        allowScrollButtonsMobile: true
      }, /*#__PURE__*/React.createElement(Tab, {
        value: "report-absence",
        label: translate('Report absence'),
        wrapped: false
      }), /*#__PURE__*/React.createElement(Tab, {
        value: "reported-absences",
        label: translate('Reported absence'),
        wrapped: false
      })), tabValue === 'report-absence' && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '12px 0'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "create-button-container"
      }, /*#__PURE__*/React.createElement(Button, {
        onClick: this.toggleModal
      }, translate('Report absence'))), this.state.recentAddedText != null ? /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '10px',
          position: 'relative',
          backgroundColor: '#7ED260',
          color: '#000000',
          borderRadius: '2.5px'
        }
      }, this.state.recentAddedText) : null), tabValue === 'reported-absences' && /*#__PURE__*/React.createElement("div", {
        style: {
          padding: '12px 0'
        }
      }, this.state.loading ? /*#__PURE__*/React.createElement("div", {
        className: "app-comp-content content"
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : null, absences != null && !this.state.loading ? /*#__PURE__*/React.createElement("div", null, absences.map(function (absence) {
        return _this2.renderItem(absence);
      })) : null), /*#__PURE__*/React.createElement(Snackbar, {
        open: alertOpen,
        autoHideDuration: 6000,
        onClose: function onClose() {
          return _this2.setState({
            alertOpen: false
          });
        }
      }, /*#__PURE__*/React.createElement(Alert, {
        onClose: function onClose() {
          return _this2.setState({
            alertOpen: false
          });
        },
        severity: alertSeverity,
        sx: {
          width: '100%'
        }
      }, alertMessage)));
    }
  }]);
}(Component);
function mapStateToProps(state) {
  return {
    submitResult: state.absence.submitResult,
    absences: state.absence.user,
    student: state.User.activeStudent,
    attendance: state.attendance.user,
    translate: translate(state.Languages.translations)
  };
}
export default connect(mapStateToProps, {
  getUserAbsence: getUserAbsence,
  updateAbsence: updateAbsence,
  setPageTitle: setPageTitle,
  submitAbsence: submitAbsence
  // leave actions removed; handled by LeavesPage
})(Absence);